"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.axiosAuth = void 0;

var _axios = _interopRequireDefault(require("axios"));

var _environment = _interopRequireDefault(require("environment"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
} // console.log("***** react-axios process: ", process.env.NODE_ENV);
// console.log("***** react-axios environment.isDevelopment: ", environment.isDevelopment);


var axiosAuth = _axios["default"].create({
  baseURL: _environment["default"].isDevelopment ? "http://localhost:3002" : "https://www.dreamchimney.com/api"
  /* other custom settings */

});

exports.axiosAuth = axiosAuth;

var reactAxios = _axios["default"].create({
  baseURL: _environment["default"].isDevelopment ? "http://www.dc.local" : "https://www.dreamchimney.com"
  /* other custom settings */

});

var _default = reactAxios;
exports["default"] = _default;